import React from "react";
import "./RevenuePage.css";

export default function RevenuePage() {
  return (
    <div className="revenue-dash-page">
      <header className="revenue-dash-page-header">
        <h2>Revenue Analytics</h2>
      </header>
    </div>
  );
}
